import React from "react";
import styled from "styled-components";
import { mobile } from "@ui/styles/utils";
import { ButtonsSection } from "./buttonsSection";
import { ColorsSection } from "./colorsSection";
import { IconsSection } from "./iconsSection";
import { InputsSection } from "./inputsSection";
import { TypographySection } from "./typographySection";

const links = [
	{ href: "#colors", label: "Couleurs" },
	{ href: "#typography", label: "Typographie" },
	{ href: "#buttons", label: "Boutons" },
	{ href: "#inputs", label: "Inputs" },
	{ href: "#icons", label: "Icônes" },
];

export const DebugPage: React.FC = () => {
	return (
		<Page>
			<Nav>
				<Title>Design system</Title>
				{links.map((link) => (
					<a key={link.href} href={link.href}>
						{link.label}
					</a>
				))}
			</Nav>
			<Main>
				<ColorsSection />
				<TypographySection />
				<ButtonsSection />
				<InputsSection />
				<IconsSection />
			</Main>
		</Page>
	);
};

const Page = styled.div`
	width: min(1200px, calc(100vw - 32px));
	margin: 88px auto 48px;
	display: grid;
	grid-template-columns: 180px 1fr;
	gap: 28px;
	align-items: start;

	@media ${mobile} {
		grid-template-columns: 1fr;
		margin-top: 80px;
	}
`;

const Nav = styled.nav`
	position: sticky;
	top: 88px;
	display: flex;
	flex-direction: column;
	gap: 8px;

	a {
		color: ${({ theme }) => theme.colors.textSecondary};
		font-weight: 600;
		font-size: 0.9rem;
	}

	a:hover {
		color: ${({ theme }) => theme.colors.primary};
	}

	@media ${mobile} {
		position: static;
		flex-direction: row;
		flex-wrap: wrap;
	}
`;

const Title = styled.p`
	margin: 0 0 8px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.textPrimary};
`;

const Main = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	min-width: 0;
`;
